import { useNavigate } from "react-router-dom";
import logo from '../images/roscroft_logo.png'
import pj_interior from '../images/auth_pj_interior.jpg'
import { useContext, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { BarLoader, GridLoader, PropagateLoader, RiseLoader } from "react-spinners";
import { useCookies } from "react-cookie";
import { TostMessageContext } from "../context/TostMessage";
import { UserContext } from "../context/UserContext";
import { BiArrowBack } from "react-icons/bi";
import { FaGlobeAfrica } from "react-icons/fa";

const EyeIcon = ({ open = false, className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2.5 12s3.6-7.5 9.5-7.5S21.5 12 21.5 12s-3.6 7.5-9.5 7.5S2.5 12 2.5 12Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    {!open && (
      <path
        d="M4 20 20 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    )}
  </svg>
);

const LogoMark = () => (
  <div className="flex items-center gap-2">
    <img src={logo} className="h-[50px] rounded-full mr-2" alt="logo" />
  </div>
);

const Input = ({ label, ...props }) => (
  <label className="block">
    <span className="mb-2 block text-[11px] tracking-widest text-white/60">
      {label}
    </span>
    <input
      {...props}
      className={[
        "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3",
        "text-white/90 placeholder:text-white/35 outline-none",
        "focus:border-[#d8b05a]/50 focus:ring-2 focus:ring-[#d8b05a]/15",
      ].join(" ")}
    />
  </label>
);

export default function Signup() {
  const [formFields, setFormFields] = useState({phone_country: '+234'});
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cookies, setCookie] = useCookies();
  const {setTostMessage} = useContext(TostMessageContext)
  const {userProfile, setUserProfile} = useContext(UserContext);
  const navigate = useNavigate();

  const submit = async () => {
    setLoading(true);
    const postData = new FormData();
    for (const [key, value] of Object.entries(formFields)) {
        postData.append(key, value);
    }

    const date = new Date();
    let expiresDate = date.setTime(date.getTime() + 24 * 60 * 60 * 1000);

    try {
        const response = await axios.post(base_url + '/auth/signup.php', postData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        console.log(response);
        if (response.data.status) {
            setLoading(false);
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            setCookie("userProfile", response.data.user, {
                path: "/",
                maxAge: expiresDate,
                secure: true,
            });
            setUserProfile(response.data.user);
            navigate("/dashboard/home");
        } else {
            setTostMessage({
                messageType: 'error',
                message: response.data.message
            })
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
                messageType: 'error',
                message: 'Network Error'
            })
    }
  }

  return (
    <div className="h-full bg-black font-spacegrotesk">
      <div className="p-3 w-full fixed z-[10] top-0 ">
        <div className="w-auto flex gap-x-2 items-center">
            <button
                onClick={() => window.open('https://roscroftjets.com')}
                className="flex items-center gap-2 text-xs tracking-widest uppercase transition-colors cursor-pointer text-text hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 md:flex">
                <FaGlobeAfrica size={20} className="text-white" weight="regular" />
            </button>
            <span className="hidden sm:block font-regular text-lg text-white/70 underline">Back to Roscroftjets.com</span>
            <span className="sm:hidden font-regular text-lg text-white/70 underline">Roscroftjets.com</span>
        </div>
      </div>
      {/* Page frame */}
      <div className="mx-auto h-full w-full">
        <div className="relative h-full">
          <div className="grid h-full grid-cols-1 lg:grid-cols-2">
            {/* LEFT: hero */}
            <div className="relative">
              {/* Replace this with your own image path */}
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('../images/auth_pj_interior.jpg')",
                }}
              />
              {/* overlays */}
              <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/40 to-black/70 md:to-black/30" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/10" />

              <div className="relative flex h-full flex-col justify-end p-7 sm:p-10">
                <div className="max-w-md relative">
                  <h1 className="text-4xl font-semibold leading-tight text-white sm:text-5xl">
                    The New Standard
                    <br />
                    of{" "}
                    <span className="text-[#d8b05a] italic">
                      Global Travel
                    </span>
                    .
                  </h1>

                  <p className="mt-5 text-sm leading-6 text-white sm:text-[15px]">
                    Join an exclusive circle of travelers who demand nothing
                    less than perfection. From booking to arrival, experience
                    the Roscroft difference.
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT: form */}
            <div className="relative">
              {/* panel background */}
              <div className="relative flex h-full flex-col px-6 py-7 sm:px-10 sm:py-10 bg-[#1E1A14]">
                <div className="flex items-center justify-between">
                  <LogoMark />
                </div>

                <div className="mt-8">
                  <h2 className="text-3xl font-semibold text-white">
                    Create Your Account
                  </h2>
                  <p className="mt-2 text-sm text-white/50">
                    Experience the pinnacle of private aviation.
                  </p>
                </div>

                <div className="mt-8 space-y-5">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Input autoComplete="off" name="first_name" onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) } label="FIRST NAME" placeholder="e.g. Alexander" />
                    <Input name="last_name" onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) } label="LAST NAME" placeholder="e.g. Sterling" />
                  </div>

                  <Input
                    label="EMAIL ADDRESS"
                    name="email"
                    autoComplete="off"
                    onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) }
                    type="email"
                    placeholder="alexander@sterling-holdings.com"
                  />

                  <div>
                    <span className="mb-2 block text-[11px] tracking-widest text-white/60">
                      PHONE NUMBER
                    </span>
                    <div className="grid grid-cols-[110px_1fr] gap-3">
                      <div className="relative">
                        <select
                          className={[
                            "w-full appearance-none rounded-xl border border-white/10 bg-white/5 px-4 py-3",
                            "text-white outline-none",
                            "focus:border-[#d8b05a]/50 focus:ring-2 focus:ring-[#d8b05a]/15",
                          ].join(" ")}
                          defaultValue="+234"
                          name="phone_country"
                          onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) }
                        >
                          <option value="+1">+1 US</option>
                          <option value="+44">+44 UK</option>
                          <option value="+234">+234 NG</option>
                          <option value="+971">+971 UAE</option>
                        </select>
                        <svg
                          className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-white/55"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M7 10l5 5 5-5"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      <input
                        className={[
                          "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3",
                          "text-white/90 placeholder:text-white/35 outline-none",
                          "focus:border-[#d8b05a]/50 focus:ring-2 focus:ring-[#d8b05a]/15",
                        ].join(" ")}
                        placeholder="202-555-0123"
                        inputMode="tel"
                        name="phone_number"
                        onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) }
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <label className="block">
                      <span className="mb-2 block text-[11px] tracking-widest text-white/60">
                        PASSWORD
                      </span>
                      <div className="relative">
                        <input
                          type={showPwd ? "text" : "password"}
                          className={[
                            "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 pr-12",
                            "text-white/90 placeholder:text-white/35 outline-none",
                            "focus:border-[#d8b05a]/50 focus:ring-2 focus:ring-[#d8b05a]/15",
                          ].join(" ")}
                          placeholder="••••••••"
                          name="password"
                          onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) }
                        />
                        <button
                          type="button"
                          onClick={() => setShowPwd((v) => !v)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-2 text-white/55 hover:text-white/80"
                          aria-label={showPwd ? "Hide password" : "Show password"}
                        >
                          <EyeIcon open={showPwd} className="h-5 w-5" />
                        </button>
                      </div>
                    </label>

                    <label className="block">
                      <span className="mb-2 block text-[11px] tracking-widest text-white/60">
                        CONFIRM PASSWORD
                      </span>
                      <div className="relative">
                        <input
                          type={showPwd ? "text" : "password"}
                          className={[
                            "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 pr-12",
                            "text-white/90 placeholder:text-white/35 outline-none",
                            "focus:border-[#d8b05a]/50 focus:ring-2 focus:ring-[#d8b05a]/15",
                          ].join(" ")}
                          name="confirm_password"
                          onChange={(e) => setFormFields({ ...formFields, [e.target.name]: e.target.value }) }
                          placeholder="••••••••"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPwd((v) => !v)}
                          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-2 text-white/55 hover:text-white/80"
                          aria-label={
                            showPwd ? "Hide confirm password" : "Show confirm password"
                          }
                        >
                          <EyeIcon open={showPwd} className="h-5 w-5" />
                        </button>
                      </div>
                    </label>
                  </div>

                  <label className="flex items-start gap-3 pt-1">
                    <input
                      type="checkbox"
                      className="mt-1 h-4 w-4 rounded border-white/20 bg-white/5 text-[#d8b05a] focus:ring-[#d8b05a]/30"
                    />
                    <span className="text-sm text-white/50">
                      I agree to the{" "}
                      <a href="#" className="text-[#d8b05a] hover:underline">
                        Terms of Service
                      </a>{" "}
                      and{" "}
                      <a href="#" className="text-[#d8b05a] hover:underline">
                        Privacy Policy
                      </a>
                      .
                    </span>
                  </label>

                  <button
                    type="submit"
                    onClick={() => loading ? null : submit()}
                    className={[
                      "mt-2 w-full rounded-xl bg-[#d8b05a] px-5",
                      "h-[50px] text-white",
                      "text-sm font-semibold tracking-widest text-black",
                      "hover:brightness-110 active:brightness-95 cursor-pointer",
                      "focus:outline-none focus:ring-4 focus:ring-[#d8b05a]/20",
                    ].join(" ")}
                  >
                    {loading ? <BarLoader
                        color={'#ffffff'}
                        loading={true}
                        size={10}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    /> : 
                        'CREATE ACCOUNT'
                    }
                  </button>

                  <div className="pt-3 text-center text-sm text-white/50">
                    Already have an account?{" "}
                    <a onClick={() => navigate("/login")} className="cursor-pointer text-[#d8b05a] hover:underline">
                      Log In
                    </a>
                  </div>
                </div>

                <div className="mt-auto pt-8">
                  <div className="flex items-center justify-center gap-8 text-xs tracking-widest text-white/25">
                    <a href="#" className="hover:text-white/45">
                      SUPPORT
                    </a>
                    <a href="#" className="hover:text-white/45">
                      GLOBAL NETWORK
                    </a>
                    <a href="#" className="hover:text-white/45">
                      LEGAL
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}